// shell-sdk/src/events.js

const listeners = new Map();

/**
 * Registra un listener para un evento
 */
export function on(eventName, callback) {
    if (!listeners.has(eventName)) {
        listeners.set(eventName, []);
    }

    const list = listeners.get(eventName);
    list.push(callback);

    return () => off(eventName, callback);
}

/**
 * Elimina un listener
 */
export function off(eventName, callback) {
    if (!listeners.has(eventName)) return;

    const list = listeners.get(eventName);
    const index = list.indexOf(callback);

    if (index >= 0) {
        list.splice(index, 1);
    }
}

/**
 * Emite un evento
 */
export function emit(eventName, payload) {
    if (!listeners.has(eventName)) return;

    const list = listeners.get(eventName);

    list.forEach((cb) => {
        try {
            cb(payload);
        } catch (err) {
            console.error("[shell-sdk] listener error:", err);
        }
    });
}

/**
 * Limpia todos los listeners (útil para tests)
 */
export function clearAll() {
    listeners.clear();
}